
import { PasswordValidationDto } from '../../dto/passwordvalidation/passwordvalidationdto';
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';


export interface PasswordValidationRequest extends APIRequest
{
    getPasswordValidationRequest(): PasswordValidationDto;
}

export class PasswordValidationRequestImpl extends APIRequestDtoImpl implements PasswordValidationRequest
{
    constructor(private passwordValidationData: PasswordValidationDto)
    {
        super();
    }

    getPasswordValidationRequest(): PasswordValidationDto
    {
        return this.passwordValidationData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/passwordvalidation/passwordvalidationrequest.tsx